var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.value)?_c('span'):_c('span',[_vm._v("X")])
}
var staticRenderFns = []

export { render, staticRenderFns }